<template>
  <v-card class="my-0 py-0">
    <v-card-text :class="`mb-0 pb-0 ${cardTextClass}`">
      <v-row class="pb-3">
        <v-col cols="12" class="mb-1" v-if="showAdresasForeign">
          <el-switch
            :label="$t('Gyvenamosios vietos adresas ne LR')"
            :tooltip="
              `${
                ntrpaslaugos ? 'NtrPaslaugos. ' : ''
              }Modalas asmuo. Adresas. Gyvenamosios vietos adresas ne LR`
            "
            :readonly="readonly"
            v-model="searchSelect.adresas_foreign"
          />
        </v-col>
        <v-col cols="12" class="mb-2">
          <el-text-field
            :label="$t('Adresas')"
            :tooltip="
              `${ntrpaslaugos ? 'NtrPaslaugos. ' : ''}Modalas asmuo. Adresas`
            "
            :readonly="readonlyAdresas"
            hideDetails="auto"
            v-model="searchSelect.text"
          />
        </v-col>
        <v-col cols="12" v-if="showPaieska">
          <el-adresas
            v-model="searchSelect"
            return-object
            :label="$t('Adreso paieška')"
            :counter="1000"
            :tooltip="
              `${
                ntrpaslaugos ? 'NtrPaslaugos. ' : ''
              }Modalas asmuo. Adreso paieška`
            "
            :autofocus="autofocus"
          />
        </v-col>
        <v-col cols="12" class="my-0 py-0" v-if="showKeistiVisus">
          <el-checkbox
            label="Pakeisti asmens adresą visame dokumente"
            tooltip="Modalas asmuo. Pakeisti asmens adresą visame dokumente"
            :readonly="readonly"
            v-model="keistiVisus"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ElAsmuoAdresas',
  props: {
    value: Object,
    readonly: Boolean,
    foreign: Boolean,
    fizinis: Boolean,
    dubliuSkaicius: Number,
    autofocus: { type: Boolean, default: false },
    ntrpaslaugos: { type: Boolean, default: false },
  },
  data() {
    return {
      keistiVisus: false,
    }
  },
  watch: {
    keistiVisus(val) {
      this.searchSelect.keisti_visus = val
    },
  },
  computed: {
    ...mapGetters(['appSavitarna']),
    searchSelect: {
      get() {
        return this.value
      },
      set(elValue) {
        elValue.keisti_visus = this.keistiVisus
        this.$emit('input', elValue)
      },
    },
    isSavitarna() {
      return this.appSavitarna
    },
    showAdresasForeign() {
      return (
        (!this.isSavitarna || this.ntrpaslaugos) &&
        !this.foreign &&
        this.fizinis
      )
    },
    readonlyAdresas() {
      return (
        this.readonly || (!this.foreign && !this.searchSelect.adresas_foreign)
      )
    },
    showPaieska() {
      return !this.readonly && !this.searchSelect.adresas_foreign
    },
    showKeistiVisus() {
      return !this.ntrpaslaugos && !this.readonly && this.dubliuSkaicius > 1
    },
    cardTextClass() {
      if (this.ntrpaslaugos) {
        return ''
      }
      return 'ma-0 pa-0'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
